var _path, _path2, _path3, _path4, _path5, _rect, _rect2, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearchbarEmptystate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 280,
    height: 280,
    viewBox: "0 0 280 280",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.663 127.029C52.663 127.029 91.4339 125.477 99.8124 61.7457C107.253 5.14635 172.631 30.9083 191.529 53.4702C216.01 82.6971 202.96 132.974 234.629 139.325C266.298 145.676 245.618 216.293 197.546 209.533C137.746 201.125 152.214 236.069 134.262 250.86C121.379 261.475 68.5513 251.256 66.7907 212.723C65.3091 180.297 51.6314 180.4 41.9365 176.723C27.9543 171.421 19.1439 133.017 52.663 127.029Z",
    fill: "#DEE9FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M184.462 197.807L146.371 160.167L138.828 167.801L176.92 205.44L184.462 197.807Z",
    fill: "#764BA2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M199.013 207.92L169.378 178.637C169.213 178.474 168.947 178.476 168.784 178.641L157.567 189.992C157.404 190.157 157.406 190.423 157.571 190.586L187.206 219.869C187.371 220.032 187.637 220.031 187.8 219.866L199.017 208.514C199.18 208.349 199.178 208.083 199.013 207.92Z",
    fill: "#280948"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M112.611 179.097C138.816 179.097 160.06 157.853 160.06 131.648C160.06 105.442 138.816 84.1982 112.611 84.1982C86.405 84.1982 65.1611 105.442 65.1611 131.648C65.1611 157.853 86.405 179.097 112.611 179.097Z",
    fill: "#764BA2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M112.611 171.355C134.54 171.355 152.318 153.578 152.318 131.648C152.318 109.718 134.54 91.9407 112.611 91.9407C90.6808 91.9407 72.9033 109.718 72.9033 131.648C72.9033 153.578 90.6808 171.355 112.611 171.355Z",
    fill: "#D4E5FF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 100.503,
    y: 121.963,
    width: 4,
    height: 33.1399,
    rx: 2,
    transform: "rotate(-45 100.503 121.963)",
    fill: "#764BA2"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 123.708,
    y: 119,
    width: 4,
    height: 33.5279,
    rx: 2,
    transform: "rotate(45 123.708 119)",
    fill: "#764BA2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M243.982 147.996C246.372 147.996 248.31 149.935 248.31 152.325C248.31 154.717 246.372 156.654 243.982 156.654C241.592 156.654 239.654 154.717 239.654 152.325",
    stroke: "#764BA2",
    strokeOpacity: 0.5,
    strokeWidth: 2.921,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M38.328 169C40.7178 169 42.656 170.939 42.656 173.329C42.656 175.72 40.7178 177.658 38.328 177.658C35.9382 177.658 34 175.72 34 173.329",
    stroke: "#764BA2",
    strokeOpacity: 0.54,
    strokeWidth: 2.921,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 134.663C14.2853 134.262 16.2541 132.691 16.7099 131C17.1234 132.494 18.8561 134.262 20.4199 134.396C18.66 135.018 16.9774 136.87 16.7099 138.325C16.5283 136.842 14.2004 134.878 13 134.663Z",
    fill: "#667EEA"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M184 99.6625C185.285 99.2617 187.254 97.6907 187.71 96C188.123 97.4937 189.856 99.2617 191.42 99.3959C189.66 100.018 187.977 101.87 187.71 103.325C187.528 101.842 185.2 99.8782 184 99.6625Z",
    fill: "#6956E5"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.572 209.225C86.572 210.774 85.3163 212.03 83.767 212.03C82.2185 212.03 80.9629 210.774 80.9629 209.225C80.9629 207.675 82.2185 206.419 83.767 206.419C85.3163 206.419 86.572 207.675 86.572 209.225Z",
    stroke: "#FFC000",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M171.609 53.8057C171.609 55.3554 170.353 56.6114 168.804 56.6114C167.256 56.6114 166 55.3554 166 53.8057C166 52.2559 167.256 51 168.804 51C170.353 51 171.609 52.2559 171.609 53.8057Z",
    stroke: "#FFC000",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.6091 80.8057C70.6091 82.3554 69.3535 83.6114 67.8041 83.6114C66.2556 83.6114 65 82.3554 65 80.8057C65 79.2559 66.2556 78 67.8041 78C69.3535 78 70.6091 79.2559 70.6091 80.8057Z",
    stroke: "#7C6A8F",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M170.506 240.293C168.362 241.109 165.962 240.032 165.146 237.887C164.33 235.742 165.406 233.341 167.552 232.526C169.695 231.71 172.095 232.786 172.911 234.931C173.728 237.076 172.651 239.477 170.506 240.293Z",
    stroke: "#667EEA",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M196.633 152.04C194.489 152.856 192.089 151.779 191.273 149.635C190.457 147.489 191.533 145.088 193.679 144.273C195.822 143.457 198.222 144.533 199.038 146.679C199.855 148.824 198.777 151.224 196.633 152.04Z",
    stroke: "#667EEA",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.262 48.4221C100.477 46.3579 101.514 44.0478 103.578 43.2625C105.642 42.4772 107.953 43.5134 108.737 45.5784C109.523 47.6417 108.487 49.9519 106.422 50.7372C104.358 51.5233 102.048 50.4863 101.262 48.4221Z",
    stroke: "#667EEA",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchbarEmptystate);
export default __webpack_public_path__ + "static/media/searchbar_emptystate.e0d6f056b8d6007e40c0402f58ed324b.svg";
export { ForwardRef as ReactComponent };